export default __webpack_public_path__ + "static/media/Screenshot4.29f15068.png";